import {
  ApiError,
  ClockAction,
  ClockRequest,
  ClockResponse,
} from "@/types/workSessions.type";
import { getCompanyId } from "./config.services";
import { api } from "./api";
import axios from "axios";

// =============================================
// 🕐 SERVICE DE POINTAGE
// =============================================

/**
 * Fonction pour pointer (arrivée ou départ)
 * @param pin - Code PIN de l'employé (4-6 chiffres)
 * @param action - "CLOCK_IN" pour l'arrivée, "CLOCK_OUT" pour le départ
 * @returns La réponse de l'API avec la session de travail
 */
export const clockInOut = async (
  pin: string,
  action: ClockAction
): Promise<ClockResponse> => {
  const companyId = getCompanyId();

  if (!companyId) {
    throw new Error("Pointeuse non configurée");
  }

  const requestData: ClockRequest = {
    pin,
    companyId,
    type: action,
  };

  try {
    const response = await api.post<ClockResponse>(
      "/work-sessions/clock",
      requestData
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      // Pas de réponse = serveur injoignable (réseau coupé, serveur down, timeout)
      if (!error.response) {
        throw new Error(
          "Serveur injoignable. Vérifiez votre connexion et réessayez."
        );
      }
      const apiError = error.response.data as ApiError | undefined;
      throw new Error(apiError?.message || "Erreur lors du pointage");
    }
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("Erreur lors du pointage");
  }
};
